import { ReactNode, memo, useEffect, useRef } from 'react';

import { ProgressSpinner } from 'core/ui';

import { useSessionLocation } from 'features/location';

import { PatientHome } from './PatientHome';

export const PatientHomeInit = memo<{ children?: ReactNode }>(({ children }) => {
  const isInitializedRef = useRef(false);
  const { sessionLocation, sessionLocationOptions, setSessionLocation } = useSessionLocation();

  // Pre-select the first session location if there is only one option available.  This is only done on initialization because we need
  // the user to be able to select "All Locations" if they wish.
  useEffect(() => {
    if (sessionLocation != null) return;
    if (sessionLocationOptions == null) return;
    if (isInitializedRef.current) return;

    // Pre-select the first session location if there is only one option available.  This is only done on initialization because we need
    // the user to be able to select "All Locations" if they wish.
    if (sessionLocationOptions.length === 1) {
      setSessionLocation(sessionLocationOptions[0], true);
    }

    isInitializedRef.current = true;
  }, [sessionLocation, sessionLocationOptions, setSessionLocation]);

  // Show loading spinner while sessionLocationOptions is loading
  if (sessionLocationOptions == null) {
    return <ProgressSpinner />;
  }

  return children ?? <PatientHome />;
});

PatientHomeInit.displayName = 'PatientHomeInit';
